import { Component } from "react";
import autoBind from "react-autobind";
import Footer from "../shared/Footer";
import Alert from "../shared/Alert";
import { withRouting } from "@/components/shared/withRouting";
import { VendorUtilities } from "../../utilities/VendorUtilities";

import Modal from "react-modal";
import ModalHeader from "../modals/ModalHeader";
import ModalBody from "../modals/ModalBody";

import { Button } from "../shared/Button";
import PasswordInput from "../shared/PasswordInput";
import TextInput from "../shared/TextInput";

class PasswordReset extends Component {
  constructor() {
    super();
    this.state = {
      newPassword: "",
      confirmNewPassword: "",
      newPassErr: false,
      newPassMessage: "",
      resetToken: "",
      resetError: false,
      resetMessage: "",
      resetPasswordEmailAddress: ""
    };
    autoBind(this);
  }

  clearErrors = () => {
    this.setState({
      newPassErr: false,
      newPassMessage: "",
      resetError: false,
      resetMessage: ""
    });
    if (this.props.err) {
      this.props.clearServerError();
    }
    if (this.props.errToken) {
      this.props.clearExpiredTokenError();
    }
  };

  handleFieldChange = (field, value) => {
    if (
      this.state.newPassErr ||
      this.props.err ||
      this.state.resetError ||
      this.props.errToken
    ) {
      this.clearErrors();
    }

    if (this.props.err) {
      this.props.clearServerError();
    }

    if (this.props.errToken) {
      this.props.clearExpiredTokenError();
    }

    this.setState({ [field]: value });
  };

  handleFormChange = (field, e) => {
    this.handleFieldChange(field, e.target.value);
  };

  validateFields = () => {
    if (this.state.newPassword !== this.state.confirmNewPassword) {
      this.setState({
        newPassErr: true,
        newPassMessage: "Passwords did not match"
      });
      return false;
    }
    return true;
  };

  buildPayloadObject = () => {
    return {
      reset_token: this.state.resetToken,
      password: this.state.newPassword.trim()
    };
  };

  onSubmit = () => {
    this.clearErrors();
    const canSubmit = this.validateFields();
    const payload = this.buildPayloadObject();
    if (canSubmit) {
      this.props.resetPassword(payload);
    }
  };

  setInitialState = token => {
    if (!token) {
      return;
    }
    this.setState({ resetToken: token });
  };

  componentDidMount() {
    const resetToken = this.props.location.hash.substring(1);
    if (resetToken) {
      this.setInitialState(resetToken);
    }
  }

  resetPassword = () => {
    const payload = {
      email: this.state.resetPasswordEmailAddress
    };
    if (!VendorUtilities.isEmailValid(this.state.resetPasswordEmailAddress)) {
      this.setState({
        resetError: true,
        resetMessage: "Please use a valid email address"
      });
      return false;
    }
    this.props.sendPasswordResetEmail(payload);
  };

  closeResetPassModal = () => {
    this.setState({
      resetPasswordEmailAddress: "",
      resetError: false,
      resetMessage: ""
    });
    this.props.displayModal("forgotPassword", false);
    this.props.setResetPasswordStep("info");
  };

  render() {
    const { dataLoading, modals } = this.props;
    const { newPassword, confirmNewPassword } = this.state;

    return (
      <div className="w-full h-full flex flex-col overflow-y-auto">
        <div className="block min-[800px]:flex min-[800px]:flex-row flex-auto w-full">
          <div className="flex flex-1 flex-col items-center self-center mx-auto max-lg:mb-[70px] lg:flex lg:flex-col">
            <div className="relative bg-[top_center] bg-[url('../../images/global/replicated-logo-red.svg')] bg-no-repeat bg-[length:350px] w-[586px] h-[180px] mt-[70px] max-lg:static max-lg:bg-[length:250px] max-lg:w-full max-lg:h-[100px] max-lg:!h-[60px]"></div>
          </div>

          <div className="bg-page-bg lg:ml-0 lg:text-left flex-1 min-h-0 flex flex-col items-center justify-center pb-3 auth-pages">
            {this.props.passwordResetStep === "success" ? (
              <div className="w-full max-w-[400px] mx-auto max-[430px]:w-[90%] lg:mx-0">
                <p className="font-['Montserrat',sans-serif] font-bold text-indigo-500 text-[30px] !text-left max-lg:mt-[70px] text-hex-2e96c2 leading-[1.4]">
                  Reset password
                </p>
                <p className="font-['Open_Sans',sans-serif] text-gray-410 text-base leading-[29px] font-normal text-gray-410 leading-[1.4] mt-3">
                  Your password has successfully been reset
                </p>
                <div className="flex mt-5">
                  <div className="FormButton-wrapper flex">
                    <Button
                      kind="primary-purple"
                      className="flex-none mt-2.5 mb-5 w-full !text-lg"
                      onClick={() => this.props.navigate("/login")}
                    >
                      Back to login
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full max-w-[400px] mx-auto max-[430px]:w-[90%] lg:mx-0">
                <p className="font-['Montserrat',sans-serif] font-bold text-indigo-500 text-[30px] !text-left max-lg:mt-[70px] text-hex-2e96c2 leading-[1.4]">
                  Reset password
                </p>
                <div>
                  <form>
                    <div className="FormSection-wrapper flex flex-col flex-1 min-h-0">
                      {this.state.newPassErr ? (
                        <Alert variant="error" className="mb-3">
                          {this.state.newPassMessage}
                        </Alert>
                      ) : null}
                      {this.props.err ? (
                        <Alert variant="error" className="mb-1.5">
                          {this.props.errMessage}
                        </Alert>
                      ) : null}
                      {this.props.errToken ? (
                        <Alert variant="error" className="mb-1.5">
                          <p>
                            {this.props.errTokenMessage} or
                            <span
                              className="text-hex-337ab7 text-xs font-medium hover:underline hover:cursor-pointer"
                              onClick={() => {
                                this.props.displayModal("forgotPassword", true);
                              }}
                            >
                              {" "}
                              request a new password
                            </span>
                          </p>
                        </Alert>
                      ) : null}
                      <div className="flex-1 min-h-0 mt-5 relative">
                        <label>New password</label>
                        <PasswordInput
                          name="newPassword"
                          className="Input"
                          placeholder="New password"
                          autoComplete="new-password"
                          value={newPassword}
                          onChangeValue={value =>
                            this.handleFieldChange("newPassword", value)
                          }
                        />
                      </div>
                      <div className="flex-1 min-h-0 mt-5 relative">
                        <label>Confirm new password</label>
                        <PasswordInput
                          name="confirmNewPassword"
                          className="Input"
                          placeholder="One more time"
                          autoComplete="new-password"
                          value={confirmNewPassword}
                          onChangeValue={value =>
                            this.handleFieldChange("confirmNewPassword", value)
                          }
                        />
                      </div>
                    </div>
                    <div className="FormButton-wrapper flex">
                      <Button
                        type="button"
                        kind="primary-purple"
                        size="large"
                        className="flex-none mt-2.5 mb-5 w-full !text-lg"
                        disabled={
                          dataLoading.resettingPasswordLoading ||
                          newPassword === "" ||
                          confirmNewPassword === ""
                        }
                        onClick={this.onSubmit}
                      >
                        {dataLoading.resettingPasswordLoading
                          ? "Resetting"
                          : "Reset Password"}
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            )}
            <div className="absolute bottom-[10px] right-[10px] !text-gray-200 max-lg:mx-auto max-lg:pt-[10px] max-lg:static max-lg:w-full max-lg:text-center max-lg:min-h-[100px]">
              <Footer />
            </div>
          </div>
        </div>

        <Modal
          isOpen={modals.forgotPasswordModal}
          contentLabel="Forgot Password Modal"
          ariaHideApp={false}
          className="Modal DefaultSize"
          onRequestClose={this.closeResetPassModal}
        >
          <ModalHeader
            title="Reset your password"
            requestClose={this.closeResetPassModal}
          />
          <ModalBody>
            <div>
              {this.props.resetPasswordStep === "success" ? (
                <div>
                  <p className="text-base font-normal text-gray-800 leading-[1.4] text-center">
                    Check your inbox. If there is an account with the specified address,
                    an email will be sent with instructions for resetting the password.
                  </p>
                  <div className="mt-5 text-center">
                    <Button
                      type="button"
                      kind="primary-purple"
                      onClick={this.closeResetPassModal}
                    >
                      Ok, got it!
                    </Button>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="mb-3">
                    <p className="FormLabel m-0">
                      What is your email address?
                    </p>
                    {this.state.resetError ? (
                      <Alert variant="error" className="mb-1.5">
                        {this.state.resetMessage}
                      </Alert>
                    ) : null}
                    {this.props.err ? (
                      <Alert variant="error" className="mb-1.5">
                        {this.props.errMessage}
                      </Alert>
                    ) : null}
                    <TextInput
                      name="resetPasswordEmailAddress"
                      type="text"
                      placeholder="you@example.com"
                      value={this.state.resetPasswordEmailAddress}
                      onChangeValue={value =>
                        this.handleFieldChange("resetPasswordEmailAddress", value)
                      }
                    />
                  </div>
                  <div className="FormButton-wrapper text-right">
                    <Button
                      kind="secondary-gray"
                      type="button"
                      className="mr-3"
                      onClick={this.closeResetPassModal}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="button"
                      kind="primary-purple"
                      disabled={
                        this.state.resetPasswordEmailAddress === "" ||
                        dataLoading.passwordResetLoading
                      }
                      onClick={this.resetPassword}
                    >
                      {dataLoading.passwordResetLoading ? "Sending" : "Send email"}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default withRouting(PasswordReset);
